import styled from 'styled-components';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    grid-template-columns: 1fr;
    > div:first-child {
      order: 2;
    }
  }
`;
export const TitleContainer = styled<{ isDesktop: boolean }>(Text)`
  width: 100%;
  height: ${({ theme: { spacing } }) => spacing.spacing_40};
  display: ${({ isDesktop }) => (isDesktop ? 'block' : 'none')};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: ${({ isDesktop }) => (isDesktop ? 'none' : 'block')};
  }
`;

export const Container = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.grad_500};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  border-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const BulletsContainer = styled(FlexContainer)`
  max-width: 400px;
`;

export const ServiceTitle = styled(FlexContainer)`
  height: 25px;
  h2 {
    color: ${({ theme: { colors } }) => colors.dark_500};
  }
`;
